import {IActionModel} from "../../shared/models/action.model";
import {SET_SELECTED_LAB} from "../actions/selectedLab.action";

export interface ISelectedLabReducerState {
    selectedLab: any;
}

const INITIAL_STATE: any = {
    selectedLab:undefined
};

const SelectedLabReducer = (state: any = INITIAL_STATE, action: IActionModel): any => {
    switch (action.type) {
        case SET_SELECTED_LAB:
            return {
                ...state,
                selectedLab: action.payload,
            };
        default:
            return state;
    }
};

export default SelectedLabReducer;